export default __webpack_public_path__ + "static/media/photo-11.7007bf48.jpeg";